// select the open-btn button
let openBtn = document.getElementById('open-btn');
// select the modal-background
let modalBackground = document.getElementById('modal-background');
// select the close-btn 
let closeBtn = document.getElementById('close-btn');
let dicount_link = document.getElementById('discount-link--js');
// display the modal on page load

window.onload = function() {
  if(localStorage.getItem("discount_modal") == 'hidden'){
    modalBackground.classList.remove("modal_visually");
  }else{
    modalBackground.classList.add("modal_visually");
  }
};

if(dicount_link){
  dicount_link.addEventListener('click', function() {
    modalBackground.classList.remove("modal_visually");
    localStorage.setItem("discount_modal", "hidden");
  });
}

// hides the modal when the user clicks close-btn
if (closeBtn) {
  closeBtn.addEventListener('click', function() {
    modalBackground.classList.remove("modal_visually");
    localStorage.setItem("discount_modal", "hidden");
  });
}

document.getElementById('discount-link--js').addEventListener('click', function (event) {
    event.preventDefault(); // Prevent the default anchor behavior
    document.getElementById('featured--collection').scrollIntoView({ behavior: 'smooth' });
});

// hides the modal when the user clicks outside the modal
window.addEventListener('click', function(event) {
  // check if the event happened on the modal-background
  if (event.target === modalBackground) {
    // hides the modal
    modalBackground.classList.remove("modal_visually");
    localStorage.setItem("discount_modal", "hidden");
  }
});
